<div style="margin: auto">
    <span>Redirecting...</span>
</div>
